import async from 'async'
import { Taf } from '@huyafed/taf-network'
import { replaceAgreement } from 'amkit3-modules/utils/replaceAgreement'
import {
  // getPlayInfo,
  getBaseInfo,
  getPlayerConfig,
} from 'amkit3-modules/utils/services/huya/v'
import { getAdInfo } from 'amkit3-modules/utils/services/huya/ad'
import { getVideoTranscodeUrlList } from 'amkit3-modules/utils/taf/api/getVideoTranscodeUrlList'
import { getVideoListByVids } from 'amkit3-modules/utils/taf/api/getVideoListByVids'
import { getDigitalDefinition } from 'amkit3-modules/v/player/profile'
// import { getDNSIP } from 'amkit3-modules/utils/huya/dns-for-cdn';

class HuyaPlayerInfo {
  constructor(options) {
    this.vid = options.vid
    this.no_ad = !!options.no_ad
    this.options = options
    this.format = 'mp4,m3u8'
    this.info = { baseInfo: { definitions: [] }, adInfo: [] }
  }
  getUrl(durationUseM3u8, definition) {
    let url = ''
    if (definition.sDuration >= durationUseM3u8) {
      url = definition.sM3u8 || definition.sUrl
    } else {
      url = definition.sUrl || definition.sM3u8
    }
    return url
  }
  getFormat(url) {
    const [src] = url.split('?')
    const index = src.lastIndexOf('.')
    const ext = src.substring(index + 1)
    const format = ext !== 'flv' && ext !== 'mp4' ? 'm3u8' : ext
    return format
  }
  init(cb) {
    // 有直出数据的时候优先
    if (this.options.videoDefinitions && this.options.videoData && this.options.playerConfig) {
      this.initData({
        videoDefinitions: this.options.videoDefinitions,
        baseInfo: this.options.videoData,
        playerConfig: this.options.playerConfig,
        cb,
      })
      return
    }
    async.parallel(
      [
        cb => {
          const vids = new Taf.Vector(new Taf.INT64())
          vids.value.push(Number(this.vid))
          getVideoTranscodeUrlList({
            vids,
          })
            .then(res => {
              const videoMap = res.transcodeInfos.value
              const videoInfo = Object.values(videoMap)[0]
              cb(null, videoInfo)
            })
            .catch(error => {
              cb(error)
            })
        },
        cb => {
          if (this.no_ad) {
            setTimeout(() => cb(null, []), 0)
          } else {
            getAdInfo('', window.location.href, this.vid, '', cb)
          }
        },
        cb => {
          const ids = new Taf.Vector(new Taf.INT64())
          ids.value.push(Number(this.vid))
          getVideoListByVids({
            ids,
          })
            .then(res => {
              const videoData = res.videoPageWrap.videos.value[0]
              cb(null, videoData)
            })
            .catch(error => {
              cb(error)
            })
        },
        // (cb) => getBaseInfo(this.vid, cb),
        cb => getPlayerConfig(cb),
      ],
      (err, results) => {
        console.log('results', results)
        this.initData({
          videoDefinitions: results[0].videoDefinitions.value,
          baseInfo: results[2],
          playerConfig: results[3],
          cb,
        })
      },
    )
  }
  initData({ videoDefinitions, baseInfo, playerConfig, cb }) {
    try {
      let adInfo = []
      let labels = {}
      const durationUseM3u8 =
        playerConfig && playerConfig.base ? playerConfig.base.durationUseM3u8 : 0
      this.info = {
        baseInfo: {
          title: baseInfo.videoTitle,
          channel: baseInfo.channelId,
          cover: replaceAgreement(baseInfo.covers.cover),
          definitions: (this.options.definitionConfig || videoDefinitions)
            .reduce((currentArr, item) => {
              const url = replaceAgreement(this.getUrl(durationUseM3u8, item))
              const definition = item.sDefinition
              const format = this.getFormat(url)
              if (!labels[definition]) {
                labels[definition] = true
                const info = {
                  url,
                  format,
                  size: item.sSize,
                  label: item.sDefName,
                  definition: definition,
                  duration: Number(item.sDuration),
                  ts1Offset: item.sTs1Offset || '0@0',
                  ts1Url: item.sTs1Url ? replaceAgreement(item.sTs1Url) : '',
                  lineType: item.iLine,
                  vStreamInfo: (item.streams || item.vStreamInfo).value.map(stream => ({
                    ...stream,
                    sCodec: stream.codec,
                    mpExtraParam: stream.extParam,
                    iBitRate: stream.iBitrate,
                    sM3u8: replaceAgreement(stream.sM3u8),
                    sTs1Url: replaceAgreement(stream.sTs1Url),
                    sUrl: replaceAgreement(stream.sUrl),
                  })),
                }
                currentArr.push(info)
              }
              return currentArr
            }, [])
            .sort((prev, next) => {
              const prevDigitalDefinition = getDigitalDefinition(prev.definition)
              const nextDigitalDefinition = getDigitalDefinition(next.definition)
              return nextDigitalDefinition - prevDigitalDefinition
            }),
        },
        adInfo: adInfo.map(item => {
          return {
            adLocation: item.adLocation,
            ati: item.ati,
            adId: item.adid,
            clickUrl: item.clickUrl,
            code: item.code,
            fodderUrl: item.fodderUrl,
            // TODO
            // fodderUrl: 'http://172.28.19.19/b38c287cb6724de9cded2cbdcedf0a94.mp4',
            // fodderUrl: 'http://172.28.19.19/test.mp4',
            height: item.height,
            width: item.width,
            videoTime: item.videoTime,
          }
        }),
      }
      // default
      this.playerConfig = playerConfig || undefined
      console.log('this.playerConfig', playerConfig)
      cb(null)
    } catch (error) {
      console.log('error', error)
      return cb(error)
    }
  }
  setDefinition(definition) {
    const { definitions } = this.info.baseInfo
    //优先拿匹配的
    let definitionConfig = definitions.find(item => item.definition === definition)
    if (!definitionConfig) {
      //其次拿第一个小于目标清晰度的
      definitionConfig = definitions.find(item => {
        const currentDigitalDefinition = getDigitalDefinition(item.definition)
        const targetDefinition = getDigitalDefinition(definition)
        return Number(currentDigitalDefinition) < Number(targetDefinition)
      })
      if (!definitionConfig) {
        //最后拿最接近的
        const definitionMap = definitions.reduce((currentMap, item) => {
          const currentDigitalDefinition = getDigitalDefinition(item.definition)
          const targetDefinition = getDigitalDefinition(definition)
          currentMap[Math.abs(targetDefinition - currentDigitalDefinition)] = item
          return currentMap
        }, {})
        const min = Math.min(...Object.keys(definitionMap))
        definitionConfig = definitionMap[min]
      }
    }
    this.definitionConfig = definitionConfig
    return definitionConfig
  }
  getDefinitionConfig() {
    return this.definitionConfig
  }
  getDefinitions() {
    return this.info.baseInfo.definitions
  }
  getCover() {
    return replaceAgreement(this.info.baseInfo.cover)
    // return this.info.baseInfo.cover
  }
  getAds() {
    return this.info.adInfo
  }
  // statistic
  getVid() {
    return this.vid
  }
  getChannelId() {
    return this.info.baseInfo.channel
  }
  getVname() {
    return this.info.baseInfo.title
  }

  // statistic cdn
  getCDN() {
    if (this.definitionConfig) {
      let url = this.definitionConfig.url
      return url.match(/\/\/(.+).huya.com/) ? url.match(/\/\/(.+).huya.com/)[1] || '' : ''
    } else {
      return ''
    }
  }
  getCDNURL() {
    if (this.definitionConfig) return this.definitionConfig.url
    else return ''
  }
}

export default HuyaPlayerInfo
